import { BENEFIT_PACK_LIST, BENEFIT_PACK_LIST_SUCCESS, BENEFIT_PACK_LIST_ERROR, BENEFIT_PACK_LIST_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const BenefitPacks = (state = initialState, action) => {
  switch (action.type) {
    case BENEFIT_PACK_LIST:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case BENEFIT_PACK_LIST_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case BENEFIT_PACK_LIST_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case BENEFIT_PACK_LIST_EMPTY:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default BenefitPacks;
